import { useMutation } from '@apollo/client';
import { Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { usePersistentSnackbar } from '../helpers';
import { RemovePropertyGroupDocument } from './remove.generated';

export const useRemovePropertyGroup = () => {
  const { enqueueSnackbar } = useSnackbar();
  const persistentSnackbar = usePersistentSnackbar();
  const { t } = useTranslation();

  const [mutationFn, mutationResult] = useMutation(RemovePropertyGroupDocument);

  const wrappedFn = useCallback<typeof mutationFn>(
    (options) =>
      mutationFn({
        onCompleted: () => {
          enqueueSnackbar(
            <Typography color="inherit">{t('api.property_groups.remove_success')}</Typography>,
            {
              variant: 'success',
            },
          );
        },

        onError: (_error: unknown) => {
          persistentSnackbar(t('api.property_groups.remove_error'), { reload: true });
        },

        ...options,
      }),
    [enqueueSnackbar, mutationFn, persistentSnackbar, t],
  );

  return [wrappedFn, mutationResult] as const;
};
